export type PaymentStatus = 'paid' | 'unpaid' | 'partially_paid';

const EPSILON = 0.001;

export function computePaymentStatus(totalDue: number, allocatedAmount: number): PaymentStatus {
  if (allocatedAmount <= EPSILON) return 'unpaid';
  if (allocatedAmount + EPSILON >= totalDue) return 'paid';
  return 'partially_paid';
}

export function sumAllocations(
  allocations: { allocatedAmount: number }[] | undefined | null,
): number {
  if (!allocations) return 0;
  return allocations.reduce((s, a) => s + (Number(a.allocatedAmount) || 0), 0);
}
